import React from "react";
import styled from "styled-components";

const UrlCorrectionBox = ({ className }) => {
    return (
        <Container className={className}>
            Please, be sure that you're on{" "}
            <span>
                <a href="https://business.kuda.com">https://business.kuda.com </a>
            </span>
        </Container>
    );
};

const Container = styled.div`
    background: #f9f9f9;
    border: 1px solid rgba(219, 220, 224, 0.5);
    box-shadow: 15px 30px 40px rgba(64, 25, 109, 0.07);
    border-radius: 5px;
    padding: 15px 26px;
    font-style: normal;
    font-weight: 700;
    font-size: 11px;
    line-height: 18px;
    color: #000000;

    a {
        text-decoration: underline;
    }
`;

export default UrlCorrectionBox;
